import axios from "axios"; 

const EWODiscripencyService = {
  // Fetch all data
  async getAll(date) {
    try {
      const response = await axios.get(`/EWODiscripency/GetEWODiscripency?p_date=${date}`, {
        // const response = await axios.get(`http://localhost:51976/EWODiscripency/GetEWODiscripency?p_date=${date}`, {
        headers: {
          
        },
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching Employee EWODiscripency:", error);
      throw error;
    }
  },

    async getIWOWithoutEWO() {
    try {
      const response = await axios.get(`/EWODiscripency/GetIWOWithoutEWO`, {
        // const response = await axios.get(`http://localhost:51976/EWODiscripency/GetEWODiscripency?p_date=${date}`, {
        headers: {
          
        },
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching Employee EWODiscripency:", error);
      throw error;
    }
  },

    async getEWOWithoutInvoice() {
    try {
      const response = await axios.get(`/EWODiscripency/GetEWOWithoutInvoice`, {
        // const response = await axios.get(`http://localhost:51976/EWODiscripency/GetEWODiscripency?p_date=${date}`, {
        headers: {
          
        },
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching Employee EWODiscripency:", error);
      throw error;
    }
  },
  
}



export default EWODiscripencyService;
